// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__CKa_9","left":"StickyBox_left__31jLv","right":"StickyBox_right__3wTNy"};